import { docuSignThemeName } from '../docuSignThemeName'
import fonts from './fonts'
import icons from './icons'
import tokens from './tokens'

export const InkDocuSignTheme = {
  name: docuSignThemeName.ink,
  fonts,
  icons,
  tokens,
} as const
